import React from 'react';

const LoadingSpinner = () => (
  <div
    style={{
      minHeight: '50vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 16,
      padding: 64,
    }}
  >
    <div
      aria-hidden="true"
      style={{
        width: 32,
        height: 32,
        background: 'var(--accent)',
        animation: 'editorial-square-pulse 1.1s ease-in-out infinite',
      }}
    />
    <p
      style={{
        margin: 0,
        fontFamily: 'var(--font-body)',
        fontSize: '0.7rem',
        fontWeight: 700,
        letterSpacing: '0.28em',
        textTransform: 'uppercase',
        color: 'var(--muted)',
      }}
    >
      Loading
    </p>
    <style>{`@keyframes editorial-square-pulse {
      0%, 100% { transform: scale(1); opacity: 1; }
      50% { transform: scale(0.7); opacity: 0.55; }
    }`}</style>
  </div>
);

export default LoadingSpinner;
